import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import useCallbackRef from 'hooks/useCallbackRef';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import FaqContext from '../providers/Faq/Faq.context';
import ManageFaqDrawer from '../components/ManageFaqDrawer';

const useManageQuestion = (question: Question) => {
  const [drawer, drawerRef] = useCallbackRef();
  const { setDisplayedQuestions } = useContext(FaqContext);
  const firstTimeSetTrue = useRef(false);

  useEffect(() => {
    if (drawer && question.openDrawerDefaultly && !firstTimeSetTrue.current) {
      drawer.setOpen(true);
      firstTimeSetTrue.current = true;
    }
  }, [drawer, question]);

  const ManageDrawer = useMemo(
    () => (
      <ManageFaqDrawer
        ref={drawerRef}
        question={question}
        onQuestionsUpdate={(question: Question) => {
          setDisplayedQuestions((old: Question[]) => {
            const ind = old.findIndex((q) => q._id === question._id);
            old.splice(ind, 1, question);
            return old;
          });
        }}
      />
    ),
    [drawerRef, question, setDisplayedQuestions],
  );

  const openDrawer = useCallback(() => drawer?.setOpen(true), [drawer]);

  return {
    ManageDrawer,
    openDrawer,
  };
};

export default useManageQuestion;
